import { useGetApplication } from 'app/hooks';
import { type TemplateForm } from 'app/modules/Parameters/NotificationTemplate/models/notificationTemplate.model';
import { type ResponseValues } from 'axios-hooks';

interface ResponseValuesExtend extends ResponseValues<TemplateForm, any, any> {
  execute: any;
}
export const useGetHeaderTemplate: (id: string, onLoadMode?: boolean) => ResponseValuesExtend = (
  id: string,
  onloadMode?: boolean
) => {
  const [{ data, loading, error, response }, execute] = useGetApplication<TemplateForm>(
    {
      url: '/taxreturntemplate',
      params: {
        language: id
      }
    },
    onloadMode === undefined ? true : onloadMode
  );

  return { loading, data, error, response, execute };
};
